/**
 * 사용자 관련 액션 생성자
 */
import { SET_USER, CLEAR_USER, UPDATE_USER_PROFILE } from './actionTypes.js';

/**
 * 사용자 정보 설정 액션
 * @param {Object} userData - 사용자 데이터 객체
 */
export const setUser = (userData) => ({
  type: SET_USER,
  payload: userData
});

/**
 * 사용자 정보 삭제 액션
 */
export const clearUser = () => ({
  type: CLEAR_USER
});

/**
 * 사용자 프로필 정보 업데이트 액션
 * @param {Object} profileData - 업데이트할 프로필 데이터
 */
export const updateUserProfile = (profileData) => ({
  type: UPDATE_USER_PROFILE,
  payload: profileData
}); 